
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {
  },
  head() {
    return {
      title: 'Frequently Asked Questions | American Credit',
      meta : [
        {
          hid: 'description',
          name: 'description',
          content: 'American Credit answers your most frequently asked questions about Asset Based Financing, Invoice Financing, and our Application Process. Call us anytime!'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Business Loan FAQs, secured business loans, asset-based loans, equipment finance, invoice financing, FAQ, American Credit'
        }
      ]
    }
  }
};
